import { Component, Input, HostBinding, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdDefaults } from '../ad-default';


@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends AdDefaults implements OnInit {


    @Input() info : any;
    @Input() template : any = 'top';
    @Input() images : any = null;
    @HostBinding('className') className = '';


    
    lastDay = '';
    viewInit = false;

    slideIndex = 0;

    available = 0;

    _images : any = [];

    swiperConfig : any = {
        init:true,
        direction: 'horizontal',
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        pagination: {
            modifierClass: 'container pagination-',
            el: '.swiper-pagination',
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                ' / ' +
                '<span class="' + totalClass + '"></span>';
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    };

    constructor( 
        protected gs : GeneralService
    ){
        super(gs);
    }

    onIndexChange(index){
        this.slideIndex = index;
    }

    ngOnInit(){
        
        let date = new Date(this.info.update);
        this.lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString();
        this.className = 'template-'+this.template;
        this._images = this.images || this.info.imagesGeneral;

        this.available = this.info?.units?.filter(item => item.status == 11)?.length || 0;
        
        super.ngOnInit();
    }

}